// Team Management
export const addMemberRolesList = ['Admin', 'Developer'];
export const deleteMemberRolesList = ['Admin', 'Developer'];
export const editMemberRolesList = ['Admin', 'Developer'];

// Company Settings
export const editCompanyPropertiesRolesList = ['Admin', 'Developer'];
export const editCompanySettingsRolesList = ['Admin', 'Developer'];
export const deleteCompanyRolesList = ['Admin']; // Only Admin can delete company

// Contacts Management
export const addCompanyContactsRolesList = [
  'Admin',
  'Developer',
  'Draft',
  'Upload',
];
export const deleteCompanyContactsRolesList = [
  'Admin',
  'Developer',
  'Draft',
  'Upload',
];
export const editCompanyContactsRolesList = [
  'Admin',
  'Developer',
  'Draft',
  'Upload',
];
export const viewContactsRolesList = ['Admin', 'Developer', 'Draft', 'Upload'];

// Document Operations
export const uploadDocumentRolesList = ['Admin', 'Developer', 'Upload'];
export const deleteDocumentRolesList = ['Admin', 'Developer'];
export const createFolderRolesList = [
  'Admin',
  'Developer',
  'Draft',
  'Upload',
  'Sign',
  'Approve',
  'Signer',
  'Approver',
  'Drafter',
  'Uploader',
];
export const draftDocumentRolesList = ['Admin', 'Developer', 'Draft', 'Upload'];
export const sendForSigningRolesList = [
  'Admin',
  'Developer',
  'Draft',
  'Upload',
];

// Template Management
export const uploadTemplateRolesList = ['Admin', 'Developer', 'Upload'];
export const createTemplateRolesList = [
  'Admin',
  'Developer',
  'Draft',
  'Upload',
];
export const editTemplateRolesList = ['Admin', 'Developer', 'Upload'];
export const deleteTemplateRolesList = ['Admin', 'Developer'];
export const draftFromTemplateRolesList = [
  'Admin',
  'Developer',
  'Draft',
  'Upload',
];

// Document Workflow
export const signDocumentRolesList = ['Admin', 'Developer', 'Sign'];
export const approveDocumentRolesList = ['Admin', 'Developer', 'Approve'];

// Sidebar Access
export const viewDocumentsRolesList = [
  'Admin',
  'Developer',
  'Draft',
  'Upload',
  'Sign',
  'Approve',
  'View',
];
export const viewTemplatesRolesList = [
  'Admin',
  'Developer',
  'Draft',
  'Upload',
  'View',
];
export const viewIntegrationsRolesList = ['Admin', 'Developer'];
export const viewSettingsRolesList = ['Admin', 'Developer'];

// Data Export
export const exportDataRolesList = ['Admin', 'Developer'];

// Custom Fields
export const createCustomFieldsRolesList = ['Admin', 'Developer', 'Draft', 'Sign'];
export const editCustomFieldsRolesList = ['Admin', 'Developer', 'Draft', 'Sign'];
export const deleteCustomFieldsRolesList = ['Admin', 'Developer', 'Draft', 'Sign'];

export const isAuthorized = (userRole: string[], allowedRoles: string[]) => {
  if (
    !userRole ||
    userRole.length === 0 ||
    !allowedRoles ||
    allowedRoles.length === 0
  ) {
    return true;
  }
  return userRole.some(role => allowedRoles.includes(role));
};
